import { debounce } from '@repo/utils/debounce'
import { ospreyAPI } from '@repo/api/ospreyAPI'
import { storeWrapper } from '../storeWrapper'

const initialState = {
  matterBundles: []
}

export const useMatterBundleStore = storeWrapper('useMatterBundleStore', (set, get) => ({
  ...initialState,
  deleteBundle: async ({ clientNo, matterNo, matterBundleId, suppressErrorToast = false }) => {
    await ospreyAPI({
      method: 'DELETE',
      service: 'documents',
      endpoint: `Bundledocs/DeleteBundle/${matterBundleId}`,
      suppressErrorToast,
      successToast: {
        type: 'success',
        title: 'Success',
        text: 'Bundle has been deleted'
      }
    })

    return get().fetchMatterBundles({ clientNo, matterNo })
  },
  fetchMatterBundles: async ({ clientNo, matterNo }) => {
    return new Promise((resolve) => {
      debounce({
        id: `fetchMatterBundles-${clientNo}-${matterNo}`,
        delay: 300,
        callback: async () => {
          try {
            const matterBundles =
              (await ospreyAPI({
                method: 'GET',
                service: 'documents',
                endpoint: `MatterBundle/GetByClientNoAndMatterNo/${clientNo}/${matterNo}`
              })) || []

            set({ matterBundles })
            resolve(matterBundles)
          } catch (err) {
            console.error('Error fetching matter bundles:', err)
            set({ matterBundles: [] })
            resolve([])
          }
        }
      })
    })
  },
  reset: () => set(initialState)
}))
